import { useCommon } from '@/core/useCommon'
import { useConfigStore } from '@/store/config/useConfigStore'
import { useUserStore } from '@/store/user/useUserStore'
import { useMemo } from 'react'

// header 上的使用者資訊 Hook
export const useUserData = () => {
  const { t } = useCommon()
  const userInfo = useUserStore((state) => state.userInfo)
  const config = useConfigStore((state) => state.config)

  // 代理等級名稱
  const myAgent = useMemo(() => {
    // 是否是大代理
    if (userInfo?.isBigAgent === 1) return t('old:common.menuTitle.bigAgent')
    // 是否是投注站
    if ((config?.creditSystem === 0 && config?.bettingStation === 1 && userInfo?.userType === 'ZDL') || userInfo?.userType === 'SZZH') return t('old:station')
    return t('old:constants.agentLevel.agent')
  }, [userInfo, t, config])

  return {
    userInfo, // 使用者資訊
    myAgent, // 代理等級名稱
  }
}
